import { useQuery } from "@tanstack/react-query"

import { getNotificaciones } from "../services/notificaciones.service";

export const useNotificaciones = () => {

    const notificacionesQuery = useQuery({
        queryKey: ['notificaciones'],
        queryFn: () => getNotificaciones(),
        staleTime: 0, // nulo
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchInterval: 60_000, //60 segundos  
        refetchIntervalInBackground: true,
        placeholderData: {
            data: {}
        }
    });

    return {
        notificacionesQuery,
    }
}